import * as React from 'react';

import { getPrivacyPolicyUrl } from './utils';
import { PersonalAgreement } from '../../components/RequestFormModal';
import { useApplicationContext } from '../../utils/applicationContext';

export const RequestFormModalPersonalAgreementContainer = () => {
  const { config } = useApplicationContext();

  const policyUrl = getPrivacyPolicyUrl(config);

  return <PersonalAgreement policyUrl={policyUrl} />;
};
